import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { bannerRegularRolesRBAC } from '../pages/Banner/rbac'
import { bannerThematicRolesRBAC } from '../pages/BannerThematic/rbac'
import { bannerThematicAddEditRolesRBAC } from '../pages/BannerThematicAddEdit/rbac'
import { PromotionReferralWidgetRBAC } from '../pages/PromoWidget/rbac'

const BannerThematicAddEdit = lazy(() => import('../pages/BannerThematicAddEdit'))
const BannerThematic = lazy(() => import('../pages/BannerThematic'))
const Banner = lazy(() => import('../pages/Banner'))
const PromoWidget = lazy(() => import('../pages/PromoWidget'))

export const BannerThematicRouter: RouterFeatureInterface<
  'BannerThematicRouter',
  '/dashboard/banner-thematic'
> = {
  name: 'BannerThematicRouter',
  Component: BannerThematic,
  path: '/dashboard/banner-thematic',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: bannerThematicRolesRBAC.pageID,
  isDashboard: true,
}

export const BannerThematicAddEditRouter: RouterFeatureInterface<
  'BannerThematicAddEditRouter',
  '/dashboard/banner-thematic/:prefix(create|edit)/:id?'
> = {
  name: 'BannerThematicAddEditRouter',
  Component: BannerThematicAddEdit,
  path: '/dashboard/banner-thematic/:prefix(create|edit)/:id?',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: bannerThematicAddEditRolesRBAC.pageID,
  isDashboard: true,
}

export const BannerRouter: RouterFeatureInterface<'BannerRouter', '/dashboard/banner'> = {
  name: 'BannerRouter',
  Component: Banner,
  path: '/dashboard/banner',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: bannerRegularRolesRBAC.pageID,
  isDashboard: true,
}

export const PromoReferralWidgetRouter: RouterFeatureInterface<
  'PromoReferralWidgetRouter',
  '/dashboard/promo-referral-widget'
> = {
  name: 'PromoReferralWidgetRouter',
  Component: PromoWidget,
  path: '/dashboard/promo-referral-widget',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: PromotionReferralWidgetRBAC.pageID,
}

const BannerAndTickerRouter = [
  BannerThematicAddEditRouter,
  BannerThematicRouter,
  BannerRouter,
  PromoReferralWidgetRouter,
]

export const BannerAndTickerRouterDetail = generateRouterDetail(BannerAndTickerRouter)

export default BannerAndTickerRouter
